var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommReactionCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14712_8975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.34888 19.25H23.5841L21.5837 17.2496C20.3122 15.9781 19.5833 14.218 19.5833 12.4202V6.35938C19.5833 4.42078 18.0062 2.84375 16.0676 2.84375H4.34888C2.41028 2.84375 0.833252 4.42078 0.833252 6.35938V15.7344C0.833252 17.673 2.41028 19.25 4.34888 19.25ZM5.52075 7.53125H14.8958V9.875H5.52075V7.53125ZM5.52075 12.2188H14.8958V14.5625H5.52075V12.2188Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4583 0.5C26.289 0.5 22.0833 4.7057 22.0833 9.875C22.0833 15.0443 26.289 19.25 31.4583 19.25C36.6275 19.25 40.8333 15.0443 40.8333 9.875C40.8333 4.7057 36.6275 0.5 31.4583 0.5ZM32.6301 6.35938H34.9739V8.70312H32.6301V6.35938ZM27.9426 6.35938H30.2864V8.70312H27.9426V6.35938ZM33.6681 14.9539C33.3374 14.0189 32.4493 13.3906 31.4583 13.3906C30.4672 13.3906 29.5791 14.0189 29.2472 14.9539L27.0386 14.1711C27.7011 12.3023 29.4773 11.0469 31.4583 11.0469C33.4392 11.0469 35.2154 12.3023 35.8768 14.1711L33.6681 14.9539Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3185 24.0938H25.5997C23.6611 24.0938 22.0841 25.6708 22.0841 27.6094V33.6702C22.0841 35.468 21.3551 37.2281 20.0837 38.4995L18.0833 40.5H37.3185C39.2571 40.5 40.8341 38.923 40.8341 36.9844V27.6094C40.8341 25.6708 39.2571 24.0938 37.3185 24.0938ZM36.1466 35.8125H26.7716V33.4688H36.1466V35.8125ZM36.1466 31.125H26.7716V28.7812H36.1466V31.125Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 21.75C5.03896 21.75 0.833252 25.9557 0.833252 31.125C0.833252 36.2943 5.03896 40.5 10.2083 40.5C15.3775 40.5 19.5833 36.2943 19.5833 31.125C19.5833 25.9557 15.3775 21.75 10.2083 21.75ZM11.3801 27.6094H13.7239V29.9531H11.3801V27.6094ZM6.69263 27.6094H9.03638V29.9531H6.69263V27.6094ZM10.2083 35.8125C8.22731 35.8125 6.45114 34.5571 5.78966 32.6883L7.99833 31.9055C8.32911 32.8405 9.21716 33.4688 10.2083 33.4688C11.1993 33.4688 12.0874 32.8405 12.4193 31.9055L14.6279 32.6883C13.9654 34.5571 12.1892 35.8125 10.2083 35.8125Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14712_8975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.833252 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommReactionCount);
export default __webpack_public_path__ + "static/media/comm_reaction_count.305907001c003452fb12863aee115b5a.svg";
export { ForwardRef as ReactComponent };